import { useTranslation } from 'react-i18next';
import RoundStar from '../RoundStar';

const AddToJournalTitle = () => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        marginTop: '40px',
        width: '295px',
        height: '58px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        position: 'relative',
        borderRadius: '12px',
        backgroundColor: 'rgb(244, 252, 229)',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          zIndex: 1,
          fontFamily: 'Nunito-Regular',
          color: '#87ba3b',
          fontWeight: 'bolder',
          lineHeight: '1.5',
        }}
      >
        {t('goalsAndTagsScreen:addToJournal')}
      </div>
      <div
        style={{
          width: '59px',
          height: '59px',
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgb(244, 252, 229)',
          borderRadius: '100%',
        }}
      >
        <div style={{ width: '41.3px', height: '41.3px' }}>
          <RoundStar color={'#87BA3B'} />
        </div>
      </div>
    </div>
  );
};

export default AddToJournalTitle;
